import { ref } from 'vue';
import LabelGroupsAPI from 'dashboard/api/labelGroups';

// v77: etiquetas permitidas POR CAIXA nos pickers da conversa (trava so de
// interface — automacoes/CLT-IA seguem livres). Cache de sessao: um fetch do
// mapa caixa->titulos; caixa fora do mapa = sem vinculo = todas liberadas.
const linksByInbox = ref(null);
let pending = null;

const load = async force => {
  if (linksByInbox.value && !force) return;
  if (pending) {
    await pending;
    return;
  }
  pending = LabelGroupsAPI.links()
    .then(({ data }) => {
      const map = {};
      (data.data || []).forEach(link => {
        map[link.inbox_id] = new Set(link.allowed_label_titles || []);
      });
      linksByInbox.value = map;
    })
    .catch(() => {
      // sem o mapa, nao restringe nada (fallback seguro)
      linksByInbox.value = linksByInbox.value || {};
    })
    .finally(() => {
      pending = null;
    });
  await pending;
};

export function useInboxAllowedLabels() {
  load();

  // Set de titulos permitidos ou null (= sem restricao)
  const allowedTitlesFor = inboxId => {
    const map = linksByInbox.value;
    if (!map || !inboxId) return null;
    return map[inboxId] || null;
  };

  const filterLabels = (labels, inboxId) => {
    const allowed = allowedTitlesFor(inboxId);
    if (!allowed) return labels;
    return (labels || []).filter(label => allowed.has(label.title));
  };

  // Varias caixas (acoes em massa): so o que e permitido em TODAS.
  const filterLabelsForInboxes = (labels, inboxIds) => {
    const ids = [...new Set((inboxIds || []).filter(Boolean))];
    if (!ids.length) return labels;
    return ids.reduce((acc, id) => filterLabels(acc, id), labels || []);
  };

  return {
    allowedTitlesFor,
    filterLabels,
    filterLabelsForInboxes,
    refreshInboxLabelLinks: () => load(true),
  };
}

// Helper para componentes Options API (contextMenu etc.): mesma regra do
// composable, reativo via ref de modulo.
export function filterLabelsByInbox(labels, inboxId) {
  load();
  const map = linksByInbox.value;
  if (!map || !inboxId) return labels || [];
  const allowed = map[inboxId];
  if (!allowed) return labels || [];
  return (labels || []).filter(label => allowed.has(label.title));
}
